












import {
  Component,
  Vue,
} from 'vue-property-decorator';

import InfoBadge from '@/components/InfoBadge.vue';
import PaymentCardModal from '@/components/PaymentCardModal.vue';
import ToTheStarsTariff from '@/components/Tariffs/ToTheStars.vue';
import TryToFlyTariff from '@/components/Tariffs/TryToFly.vue';
import InfoLayout from '@/layouts/Info.vue';
import {
  i18n,
} from '@/plugins/vue-i18n';
import {
  metaInfoHelper,
} from '@/utils/meta-info-helper';


@Component({
  name: 'tariffs',
  components: {
    ToTheStarsTariff,
    TryToFlyTariff,
    PaymentCardModal,
    InfoLayout,
    InfoBadge,
  },
  metaInfo() {
    const title = metaInfoHelper.getHeadTitle(i18n.t('views.tariffs.tariffs'));

    return {
      title,
      meta: [...metaInfoHelper.getHeaderOGMeta({ title })],
    };
  },
})
export default class Tariffs extends Vue {
  private handleActivate(): void {
    this.$modal.show('payment-card-modal');
  }
}
